export default __webpack_public_path__ + "resources/icons/n122-39a5.webp";